jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.news-slider').length ) {
        let $ = jQuery;

        $(".news-slider .js-news-slider").slick({
            centerMode: true,
            centerPadding: '60px',
            slidesToShow: 3,
            arrows: true,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1.66
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        centerMode: true,
                        centerPadding: '20px',
                        slidesToShow: 1
                    }
                },
            ]
        });
    }
});